<template>
  <a-drawer
    :title="detail ? '编辑短剧' : '新建短剧'"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
  <!-- 提示 -->
    <a-alert
      message="请先列表搜索确认【剧名】与【剧风格】不存在，避免重复添加！"
      type="warning"
      show-icon
      style="margin-bottom: 16px;"
    />
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 剧名 -->
      <a-form-item
        label="剧名"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
        />
      </a-form-item>
      
      <!-- 集数 -->
      <a-form-item
        label="集数"
        name="total_ep"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.total_ep"
          placeholder="请输入"
        >
          <template #suffix>集</template>
        </a-input>
      </a-form-item>
      
      <!-- 视频语种 -->
      <a-form-item
        label="视频语种"
        name="lang_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.lang_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 剧情频道 -->
      <a-form-item
        label="剧情频道"
        name="male_and_female"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.male_and_female"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in PlotChannels"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <!-- 剧情类型 -->
      <a-form-item
        label="剧情类型"
        name="type_ids"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          mode="multiple"
          v-model:value="formState.type_ids"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in plotTypes"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <!-- 风格 -->
      <a-form-item
        label="风格"
        name="style_type"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.style_type"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in StyleTypes"
            :key="`${item.value}-${item.text}`"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <!-- 片源 -->
      <a-form-item
        label="片源"
        name="film_type"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.film_type"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in FilmTypes"
            :key="`${item.value}-${item.text}`"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 成片供应商 -->
      <a-form-item
        v-if="formState.film_type !== 1"
        label="成片供应商"
        name="film_supplier_id"
        :rules="[{ required: true }]"
      >
        <a-select
          show-search
          :filter-option="filterOption"
          v-model:value="formState.film_supplier_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in supplierList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 分成比例 -->
      <a-form-item
        label="分成比例"
        name="cash_rate"
        :rules="[{ validator: validatorRevenueShareRatio }]"
      >
        <a-input
          v-model:value="formState.cash_rate"
          placeholder="请输入"
        >
          <template #suffix>%</template>
        </a-input>
      </a-form-item>
      
      <!-- 分成对象 -->
      <a-form-item
        label="分成对象"
        name="cash_beneficiary"
      >
        <a-input
          v-model:value="formState.cash_beneficiary"
          placeholder="请输入"
        />
      </a-form-item>
      
      <!-- 上架日期 -->
      <a-form-item
        label="上架日期"
        name="release_date"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-date-picker
          v-model:value="formState.release_date"
          placeholder="请选择"
          style="width: 100%"
        />
      </a-form-item>
      
      <!-- 发布账号 -->
      <!-- <a-form-item
        label="发布账号"
        name="account_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.account_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in accountListData"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item> -->
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <a-button v-if="detail?.id" @click="touchCopyCreate">复制创建</a-button>
        <div v-else></div>
        <div>
          <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
          <a-button type="primary" @click="touchSubmit">确定</a-button>
        </div>
      </div>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, nextTick } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { MediaTypes, AudienceTypes, ClassifySettings, FilmTypes, StyleTypes, PlotChannels } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
// 引入 API
import { ytDramaSave, langSearchList, getAllClassifyList, accountList, supplierAll } from '@/api/admin'

// emit
const emit = defineEmits(['success', 'copyCreate'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 语种列表
let languages= ref([])
// 剧情类型列表
let plotTypes = ref([])
// 供应商列表
let supplierList = ref([])
// 账号列表
let accountListData = ref([])
// 修改对象
let detail = ref(null)
// 是否为拷贝状态（复制创建：沿用当前数据但剧名/集数置空，走新建接口）
let isCopy = ref(false)

// 表单参数
const formState = ref({
  // 剧名
  name: undefined,
  // 剧情类型（多选，id数组）
  type_ids: [],
  // 总集数
  total_ep: undefined,
  // 风格（1-真人，2-漫剧，3-真人换脸，4-AI短剧）
  style_type: undefined,
  // 视频语种（语言id）
  lang_id: undefined,
  // 剧情频道（片库-剧情频道：男频/女频）
  male_and_female: undefined,
  // 片源类型 1-自制 2-外采 3-置换
  film_type: undefined,
  // 供应商id
  film_supplier_id: undefined,
  // 上架/发布日期（YYYY-MM-DD）
  release_date: undefined,
  // 分成比例（现金分成/比例）
  cash_rate: undefined,
  // 分成对象（收款方）
  cash_beneficiary: undefined,
  // 账号id（发布账号）
  account_id: undefined
})

// 显示弹窗（record 为当前编辑记录，copy 为 true 表示拷贝状态：沿用 record 数据但剧名/集数置空，走新建接口）
function showDrawer(record, copy) {
  visible.value = true
  isCopy.value = !!copy
  detail.value = copy ? null : record

  if (record && (record.id || copy)) {
    // 编辑 或 复制创建：按 record 填充，复制创建时剧名、集数置空
    nextTick(() => {
      formState.value = {
        name: copy ? undefined : record.name,
        type_ids: (record.drama_types || []).map(item => item.id),
        total_ep: copy ? undefined : record.total_ep,
        style_type: record.style_type,
        lang_id: record.lang_id,
        male_and_female: record.male_and_female,
        film_type: record.film_type,
        film_supplier_id: record.film_supplier_id,
        release_date: record.release_date ? dayjs(record.release_date) : undefined,
        cash_rate: record.cash_rate,
        cash_beneficiary: record.cash_beneficiary,
        account_id: record.account_id
      }
    })
  } else {
    // 新建模式，重置表单
    nextTick(() => {
      formState.value = {
        name: undefined,
        type_ids: [],
        total_ep: undefined,
        style_type: undefined,
        lang_id: undefined,
        male_and_female: undefined,
        film_type: undefined,
        film_supplier_id: undefined,
        release_date: undefined,
        cash_rate: undefined,
        cash_beneficiary: undefined,
        account_id: undefined
      }
    })
  }
  getSelectList()
}

// 获取选择项
function getSelectList() {
  // 语种列表
  langSearchList().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
  // 剧情类型列表
  const params = {
    source: ClassifySettings.type,
    status: 1,
    page: 1,
    page_size: 10000
  }
  getAllClassifyList(params).then(res => {
    const { code, data } = res
    if (code === 0) {
      plotTypes.value = data.list
    }
  })
  // 供应商列表
  supplierAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      supplierList.value = data
    }
  })
  // 账号列表
  accountList().then(res => {
    const { code, data } = res
    if (code === 0) {
      accountListData.value = data.data
    }
  })
}

// 表单校验（分成比例）
function validatorRevenueShareRatio(rule, value) {
  if (!value) {
    return Promise.resolve()
  } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value)) {
    return Promise.reject('必须为正数，且最多保留两位小数')
  }
  return Promise.resolve()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 关闭弹窗
function onClose() {
  visible.value = false
  // 重置表单
  RefForm.value?.resetFields()
  formState.value = {
    name: undefined,
    type_ids: [],
    total_ep: undefined,
    style_type: undefined,
    lang_id: undefined,
    male_and_female: undefined,
    film_type: undefined,
    film_supplier_id: undefined,
    release_date: undefined,
    cash_rate: undefined,
    cash_beneficiary: undefined,
    account_id: undefined
  }
  detail.value = null
  isCopy.value = false
}

// 复制创建：回调父组件，由父组件关闭当前弹窗并重新以拷贝状态打开
function touchCopyCreate() {
  const record = detail.value
  if (!record?.id) return
  emit('copyCreate', record)
  onClose()
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 拷贝状态或新建不传 id，走新建接口
    const params = {
      id: (detail.value && detail.value.id) || undefined,
      ...res,
      // 格式化时间，将dayjs对象转换为YYYY-MM-DD字符串
      release_date: res.release_date ? dayjs(res.release_date).format('YYYY-MM-DD') : undefined
    }
    isLoading.value = true
    // TODO: 替换为实际的API调用
    ytDramaSave(params).then((res) => {
      isLoading.value = false
      if (res.code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message)
      }
    }).catch(() => {
      isLoading.value = false
      message.error('保存失败')
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
